export default "__VITE_ASSET__BMDnEHWP__"